import Skeleton from 'react-loading-skeleton';
import ListSkeleton from './skeleton_table_loader';
import { SpinnerOverlay } from '../spinner';

interface PageSkeletonProps {
  /** Данные грузятся — проксируется в `ListSkeleton`. */
  loading?: boolean;
  /** Показать спиннер под скелетоном. */
  spinner?: boolean;
}

/** Скелетон загружающейся страницы-раздела (заявки, аваркомы, страховые и пр). */
const PageSkeleton = ({ loading, spinner }: PageSkeletonProps) => {
  const styleTopLine = { fontSize: 40, lineHeight: 2 };

  return (
    <>
      <div>
        <div className='row' style={ styleTopLine }>
          <div className='col-md-5'><Skeleton /></div>
          <div className='col-md-2 col-md-offset-3'><Skeleton /></div>
          <div className='col-md-2'><Skeleton /></div>
        </div>
      </div>
      <div>
        <ListSkeleton loading={ loading } />
      </div>
      { spinner && (<SpinnerOverlay loading />) }
    </>
  );
};

export default PageSkeleton;
